<template>

    <div class="page">
      <slot></slot>
    </div>
   
</template>

<script>
export default {
  name: 'page',
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// page.vue?c5bf1c5a